import React from "react";
import { useApp } from "@/context/AppContext";

export default function AdminRoute({ children }) {
  const { authReady, user } = useApp();
  if (!authReady) return <div className="rbl-auth-wrap"><div className="rbl-spinner" /></div>;
  if (!user) { window.location.replace("/login"); return null; }
  if (user.role !== "admin" && user.role !== "trainer" && user.role !== "hr") { window.location.replace("/app"); return null; }
  return children;
}
